import FramerateImage from '@images/graphics/framerate.svg';
import FrametimeImage from '@images/graphics/frametime.svg';
import * as React from 'react';
export default {
  FramerateImage,
  FrametimeImage,
  React
};